import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withAccount } from '../../../../components/AccountContext';
import { Definition as Def } from './ImportDataDisplay';
import Log from './ImportLog';
import Detail from './ImportDetailInfo';
import { SURVEY_FILE_IMPORT_STATUS } from '../../../../shared/Constants';
import { historyShape } from '../../../../components/prop-types';

class ImportDetailContainer extends Component {
  render() {
    const { data } = this.props;
    const { surveyImport } = data;

    const isValidSurveyImport = surveyImport.status === SURVEY_FILE_IMPORT_STATUS.VALID;
    const isInvalidSurveyImport = surveyImport.status === SURVEY_FILE_IMPORT_STATUS.FAILED;
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <div className="p-grid">
              <div className="p-col-12">
                <Detail imported={surveyImport} {...this.props} />
              </div>
              <div className="p-col-12">
                {isValidSurveyImport && (
                  <Def />
                )}
                {isInvalidSurveyImport && <Log def={surveyImport} {...this.props} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ImportDetailContainer.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  history: historyShape.isRequired,
};

export default withRouter(
  withAccount(ImportDetailContainer),
);
